import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function toDateOnly(value: unknown): Date | null {
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return new Date(value.getFullYear(), value.getMonth(), value.getDate());
  }

  if (typeof value === 'string') {
    const isoMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
    if (isoMatch) {
      const year = Number(isoMatch[1]);
      const month = Number(isoMatch[2]);
      const day = Number(isoMatch[3]);
      const date = new Date(year, month - 1, day);
      if (
        date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day
      ) {
        return date;
      }
    }

    const brMatch = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value);
    if (brMatch) {
      const day = Number(brMatch[1]);
      const month = Number(brMatch[2]);
      const year = Number(brMatch[3]);
      const date = new Date(year, month - 1, day);
      if (
        date.getFullYear() === year &&
        date.getMonth() === month - 1 &&
        date.getDate() === day
      ) {
        return date;
      }
    }
  }

  return null;
}

export function emissionDateNotAfterSafraStartValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const emissionDate = toDateOnly(control.value);
    const safraStart = toDateOnly(control.parent?.get('safraIDate')?.value);

    if (!emissionDate || !safraStart) {
      return null;
    }

    if (emissionDate.getTime() > safraStart.getTime()) {
      return { emissionAfterSafraStart: true };
    }

    return null;
  };
}
